"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const entity_1 = require("../../type/entity");
const getContentType_1 = require("../getContentType");
const getEnrolmentContentType_1 = require("../getEnrolmentContentType");
const getVersionIdOfContent_1 = tslib_1.__importDefault(require("../versions/getVersionIdOfContent"));
const getContentStatus_1 = tslib_1.__importDefault(require("./getContentStatus"));
const getEnrolmentAssignInfo_1 = tslib_1.__importDefault(require("./getEnrolmentAssignInfo"));
const getUnitSetting_1 = tslib_1.__importDefault(require("./getUnitSetting"));
const updateEnrolmentFields_1 = require("./updateEnrolmentFields");
function getBaseEnrolment(command, content, user) {
    const { timeStamp, userId, rootContentId } = command;
    const direct = rootContentId === content._id;
    const parentIds = rootContentId !== content._id ? [rootContentId] : [];
    const enrolmentAssignInfo = getEnrolmentAssignInfo_1.default(command, content);
    const contentStatus = getContentStatus_1.default(content);
    const enrolmentContentType = getEnrolmentContentType_1.getEnrolmentContentType(content);
    const companyId = user.companyId;
    const versionId = getVersionIdOfContent_1.default(command.versions, content._id);
    return {
        companyId,
        contentId: content._id,
        contentStatus,
        contentType: enrolmentContentType,
        contentType_contentId: `${enrolmentContentType}_${content._id}`,
        createdAt: timeStamp,
        direct,
        enrolmentInfo: [enrolmentAssignInfo],
        parentIds,
        updatedAt: timeStamp,
        userId,
        deleted: false,
        versionNumber: 0,
        versionId
    };
}
function createOfferEnrolment(command, content, user) {
    return getBaseEnrolment(command, content, user);
}
function createCurriculumEnrollement(command, content, user) {
    return getBaseEnrolment(command, content, user);
}
function createCheckPointEnrolment(command, content, user) {
    const enrolment = getBaseEnrolment(command, content, user);
    const unitSetting = getUnitSetting_1.default(command, content._id);
    updateEnrolmentFields_1.updateApproverInfoInEnrolment(enrolment, unitSetting);
    return enrolment;
}
function createILTEnrolment(command, content, user) {
    return getBaseEnrolment(command, content, user);
}
function createEnrolment(command, content, user) {
    const modelType = content.modelType;
    const contentType = getContentType_1.getContentType(content);
    switch (contentType) {
        case entity_1.ContentType.COURSE:
            return createOfferEnrolment(command, content, user);
        case entity_1.ContentType.CHECKPOINT:
            return createCheckPointEnrolment(command, content, user);
        case entity_1.ContentType.CURRICULUM:
            return createCurriculumEnrollement(command, content, user);
        case entity_1.ContentType.ILT:
            return createILTEnrolment(command, content, user);
        default:
            throw new Error('Invalid type ' + modelType);
    }
}
exports.default = createEnrolment;
//# sourceMappingURL=createEnrolment.js.map